const SET_FROM = 'SET_FROM';
const SET_TO = 'SET_TO';

const REDUCER_ACTIONS = {
  SET_FROM,
  SET_TO,
}
export default REDUCER_ACTIONS;
